import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './BackArrow.css';

function BackArrow({ to, color, onBeforeNavigate, label = 'ZURÜCK', icon = 'arrow_back' }) {
  const navigate = useNavigate();
  const [top, setTop] = useState(0);
  const [headingColor, setHeadingColor] = useState('');
  const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth <= 600);

  useEffect(() => {
    const updatePosition = () => {
      const heading = document.querySelector('.section-title');
      if (heading) {
        const rect = heading.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        setTop(rect.top + scrollTop + rect.height / 2);
        setHeadingColor(getComputedStyle(heading).color);
      } else {
        setTop(50);
        setHeadingColor('');
      }
      setIsMobile(window.innerWidth <= 600);
    };
    updatePosition();
    window.addEventListener('resize', updatePosition);
    return () => window.removeEventListener('resize', updatePosition);
  }, []);

  return (
    <div
      className={`back-arrow ${color}`}
      style={{
        top: isMobile ? 'auto' : `${top}px`,
        position: isMobile ? 'static' : 'absolute',
        color: headingColor,
      }}
      onClick={() => {
        if (!onBeforeNavigate || onBeforeNavigate()) {
          navigate(to);
        }
      }}
    >
      <span className="material-symbols-outlined">{icon}</span>
      <span className="back-text">{label}</span>
    </div>
  );
}

export default BackArrow;
